import { fileSchema, imageFileSchema } from './schemas/files';
import {
    createLocalizedCurrencyNumberSchema,
    createLocalizedNumberSchema,
    maxNonNegativeIntegerSchema,
    maxPositiveIntegerSchema,
    percentageSchema,
} from './schemas/numbers';
import { emptyStringSchema, passwordSchema, requiredStringSchema } from './schemas/strings';
import { optionalLocalizedFieldSchema, requiredLocalizedFieldSchema } from './schemas/localized';
import { flagSchema } from './schemas/flags';
import { birthDateSchema, dateRangeSchema } from './schemas/datetime';
import { createDateStringSchema, dateIsoStringSchema } from './schemas/datetime/date';

export const Validation = {
    BirthDate: {
        Iso: birthDateSchema.iso,
        Utc: birthDateSchema.utc,
        WallClock: birthDateSchema.wallClock,
    },
    Date: {
        Iso: dateIsoStringSchema,
        WallClock: createDateStringSchema,
    },
    DateRange: {
        Iso: dateRangeSchema.iso,
        Utc: dateRangeSchema.utc,
        WallClock: dateRangeSchema.wallClock,
    },
    File: {
        Default: fileSchema,
        Image: imageFileSchema,
    },
    Flag: {
        Default: flagSchema,
    },
    Localized: {
        Optional: optionalLocalizedFieldSchema,
        Required: requiredLocalizedFieldSchema,
    },
    Number: {
        LocalizedCurrencyNumber: createLocalizedCurrencyNumberSchema,
        LocalizedNumber: createLocalizedNumberSchema,
        MaxNonNegativeInteger: maxNonNegativeIntegerSchema,
        MaxPositiveInteger: maxPositiveIntegerSchema,
        Percentage: percentageSchema,
    },
    String: {
        Empty: emptyStringSchema,
        Password: passwordSchema,
        Required: requiredStringSchema,
    },
} as const;
